import React from "react";

export default function BucketsTableBMSMax(props) {
  let { data } = props;
  return (
    <>
      {(data.length == 0) ? "<tr><td colSpan={2}>No data found</td></tr>" : data.map((x, index) => {
        return (<tr key={index}>
          <td scope="row ">{x.key.vehicleId}</td>
          <td >{(x.BMS_Max_Cell_Voltag.value).toFixed(3)} </td>
        </tr>)
      })}
    </>
  );
}

